import script from "./InventoryNFT.vue?vue&type=script&setup=true&lang=ts"
export * from "./InventoryNFT.vue?vue&type=script&setup=true&lang=ts"

import "./InventoryNFT.vue?vue&type=style&index=0&id=4b3f9f65&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b3f9f65"]])

export default __exports__